import { IComponentOptions, IController } from "angular";
import { IEnrichedEmployee } from "@gtmhub/employees";
import { UIErrorHandlingService } from "@gtmhub/error-handling/services/error-handling-service";
import { ProfileService } from "@gtmhub/profile";
import { ICheckinV2 } from "@webapp/okrs/metrics/models/metric.models";

export class LatestSectionCtrl implements IController {
  target: IEnrichedEmployee;
  latestMetricUpdates: ICheckinV2[];
  showNoUpdatesMessage: boolean;
  valueHasMoreThenTwoDecimals(value: number): boolean {
    return value.toString().split(".")[1]?.length > 2;
  }
  indicators: {
    loading: boolean;
  };

  static $inject = ["UIErrorHandlingService", "ProfileService"];

  constructor(private uiErrorHandlingService: UIErrorHandlingService, private profileService: ProfileService) {
    this.indicators = {
      loading: true,
    };
  }

  $onInit(): void {
    this.profileService.getLatestMetricUpdates(this.target.type, this.target.id, { limit: 3 }).then(
      (checkins) => {
        this.latestMetricUpdates = checkins;
        if (!this.latestMetricUpdates.length) {
          this.showNoUpdatesMessage = true;
        }
        this.indicators.loading = false;
      },
      (error) => {
        this.indicators.loading = false;
        this.uiErrorHandlingService.handleModal(error);
      }
    );
  }
}

export const LatestSectionComponent: IComponentOptions = {
  bindings: {
    target: "<",
  },
  controller: LatestSectionCtrl,
  template: require("./latest-section.component.html"),
};
